export default __webpack_public_path__ + "static/media/logo-white.1240bce1.svg";